import type { IHeader2, IGlcePartnerConfig } from '../../types/contentful';

type LogoField =
  | 'abbreviatedLogoDesktop'
  | 'abbreviatedLogoMobile'
  | 'fullLogoDesktop'
  | 'fullLogoMobile';

export const isPartnerPage = (parts: string[]): boolean => {
  return (
    parts.length === 2 &&
    parts[0] === 'classrooms' &&
    parts[1] !== 'lesson-library' &&
    parts[1].length > 0
  );
};

export const findPartnerHeader = (
  gl4cPartnerHeaders: IHeader2[] | null | undefined,
  partnerName: string | undefined
): IHeader2 | null => {
  if (!gl4cPartnerHeaders || !partnerName) return null;

  return (
    gl4cPartnerHeaders.find((header: IHeader2) => {
      try {
        const logoFields: LogoField[] = [
          'abbreviatedLogoDesktop',
          'abbreviatedLogoMobile',
          'fullLogoDesktop',
          'fullLogoMobile'
        ];

        return logoFields.some((logoField: LogoField) => {
          const logoAsset = header?.fields?.[logoField];
          const fileName = logoAsset?.fields?.file?.fileName;

          if (!fileName) return false;

          // Extract filename without extension
          const baseName = fileName.split('.')[0];

          // Case-insensitive match
          return baseName.toLowerCase() === partnerName?.toLowerCase();
        });
      } catch (error) {
        return false;
      }
    }) || null
  );
};

export const findPartnerConfig = (
  glcePartnerConfig: IGlcePartnerConfig[] | null | undefined,
  partner: string | undefined
): IGlcePartnerConfig | any | null => {
  if (!glcePartnerConfig || !Array.isArray(glcePartnerConfig) || !partner) {
    return null;
  }

  try {
    return (
      glcePartnerConfig.find((config: IGlcePartnerConfig) => {
        const partnerValue = config?.fields?.partner;
        if (!partnerValue) return false;

        // Case-insensitive match
        return partnerValue.toLowerCase() === partner?.toLowerCase();
      }) || null
    );
  } catch (error) {
    return null;
  }
};
